import Box from '@ilg-totallymoney/ui/components/Box'
import Flex from '@ilg-totallymoney/ui/components/Flex'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Row from '@ilg-totallymoney/ui/components/Row'
import Text from '@ilg-totallymoney/ui/components/Text'
import Icon from '@ilg-totallymoney/ui/icons/Icon'
import theme from '@ilg-totallymoney/ui/theme'

interface ProsAndConsListProps {
    list: string[]
    listHeading: 'Great for' | 'Beware of'
}

const ProsAndConsList = ({ list, listHeading }: ProsAndConsListProps) => (
    <Box>
        <Row mb="space05" alignItems="center" space="space10">
            <Flex alignItems="center">
                {listHeading === 'Great for' ? (
                    <Icon
                        icon="alertCheckmark"
                        size={24}
                        color={theme.dataVisualisationTeal}
                    />
                ) : null}

                {listHeading === 'Beware of' ? (
                    <Icon icon="info" size={24} color={theme.alertError100} />
                ) : null}
            </Flex>

            <Heading variant="60">{listHeading}</Heading>
        </Row>

        <Box height={1} backgroundColor="productNeutral140" mb="space20" />

        <Box pl="space05" pr="space10">
            <Box
                as="ul"
                display="grid"
                gridGap="space10"
                pl="space20"
                style={{ listStyleType: 'disc' }}
            >
                {list?.map((item, i) => (
                    <Box as="li" key={`${item}-${i}`} pl="space10">
                        <Text>{item}</Text>
                    </Box>
                ))}
            </Box>
        </Box>
    </Box>
)

export default ProsAndConsList
